export default __webpack_public_path__ + "images/ca498368621c70f132278031552610a9.svg";